import { applySipBulkResultsToComplexes } from "./applySipBulkResults";

export function applyBulkStatusResultsToComplexes(complexes, results) {
  return applySipBulkResultsToComplexes(complexes, results, (result) => ({
    status: result.status,
  }));
}
